import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { brokerTypeEnumSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";

// Trimmed disclosure DTO (not the raw broker record): `licenseNumber` is present
// only when the patient's server-resolved state is CA, `null` otherwise.
const brokerDisclosureSchema = z.object({
  name: z.string(),
  licenseNumber: z.string().nullable(),
  type: brokerTypeEnumSchema,
});

const c = initContract();

export const brokersContract = c.router({
  getBroker: {
    summary: "Get the disclosure broker for the current patient's state",
    method: "GET",
    path: "/brokers",
    responses: {
      // `null` when no broker is configured for the state — an expected,
      // non-error outcome (the screen falls back to its generic copy).
      [HTTPStatusCode.OK]: brokerDisclosureSchema.nullable(),
    },
  },
});
